import { type Enum } from '@webapp/infrastructure/types/Enum'

export const OrderDraftMutationStatusStatuses = {
  UPDATING: 'updating',
  FAILED_TO_UPDATE: 'failed-to-update',
  COMPLETED: 'completed',
} as const

export type OrderDraftMutationStatusEnum = Enum<
  typeof OrderDraftMutationStatusStatuses
>
